(() => {
  const update = async root => {
    if (root.dataset.obpGuideLoading) return;
    root.dataset.obpGuideLoading = '1';
    const link = root.querySelector('[data-obp-guide-source]');
    if (!link) return;
    const source = new URL(link.getAttribute('href'), window.location.href);
    if (source.origin !== window.location.origin) return;
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 6000);
    try {
      const response = await fetch(source.href, {credentials:'same-origin',signal:controller.signal});
      if (!response.ok) return;
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const stage = doc.querySelector('[data-obp-pdp-main]');
      if (!stage) return;
      const delivery = stage.querySelector('.obp-pdp__availability');
      if (delivery && delivery.textContent.trim()) {
        root.querySelectorAll('[data-obp-guide-delivery]').forEach(el => el.textContent = delivery.textContent.replace(/\s+/g,' ').trim());
      }
    } catch (_) { /* Keep the explicit link to the maintained product source. */ }
    finally { clearTimeout(timer); }
  };
  const scan = scope => scope.querySelectorAll('[data-obp-guide]').forEach(update);
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded',()=>scan(document)); else scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
})();
